"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var MINUS_KEY = '-';
var ENTER_KEY = 'Enter';
var NO_OP = function NO_OP() {};
var AmountField = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AmountField, _Component);
  var _super = _createSuper(AmountField);
  function AmountField() {
    var _this;
    (0, _classCallCheck2.default)(this, AmountField);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      timeout: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onTextChange", function (e) {
      var value = e.target.value;
      var timeout = _this.state.timeout;
      var _assertThisInitialize = (0, _assertThisInitialized2.default)(_this),
        amountRef = _assertThisInitialize.amountRef;
      var val = e.target.value;
      var amount = /\d+?/.test(val) && +val >= 0 ? Math.ceil(+val) : '';
      if (timeout) {
        clearTimeout(timeout);
        _this.setState({
          timeout: null
        });
      }
      _this.setState({
        timeout: setTimeout(function () {
          amountRef.value = amount;
        }, 500)
      });
      _this.props.onChange(value);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onKeyPress", function (e) {
      var key = e.key;
      if (key === MINUS_KEY) return e.preventDefault();
      if (key === ENTER_KEY) return _this.props.onEnterKeyPress(e);
    });
    return _this;
  }
  (0, _createClass2.default)(AmountField, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        className = _this$props.className,
        placeholder = _this$props.placeholder;
      return /*#__PURE__*/_react.default.createElement("input", {
        "data-test-id": "amount-field-input",
        ref: function ref(ele) {
          return _this2.amountRef = ele;
        },
        min: "0",
        type: "number",
        "aria-label": placeholder,
        placeholder: placeholder,
        className: className,
        onKeyPress: this.onKeyPress,
        onChange: this.onTextChange
      });
    }
  }]);
  return AmountField;
}(_react.Component);
AmountField.defaultProps = {
  onChange: NO_OP,
  onEnterKeyPress: NO_OP,
  placeholder: 'Enter amount'
};
AmountField.propTypes = {
  onChange: _propTypes.default.func,
  onEnterKeyPress: _propTypes.default.func,
  className: _propTypes.default.string,
  placeholder: _propTypes.default.string
};
var _default = AmountField;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/pf-payment-calculator/dist/client/components/scss/index.scss');